import { render, staticRenderFns } from "./SignDetail.vue?vue&type=template&id=f1467da0&scoped=true"
import script from "./SignDetail.vue?vue&type=script&lang=js"
export * from "./SignDetail.vue?vue&type=script&lang=js"
import style0 from "./SignDetail.vue?vue&type=style&index=0&id=f1467da0&prod&lang=less&scoped=true"
import style1 from "./SignDetail.vue?vue&type=style&index=1&id=f1467da0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1467da0",
  null
  
)

export default component.exports